import { collection, doc, serverTimestamp, writeBatch } from "firebase/firestore";
import _ from 'lodash';
import { seasonalHelpers } from "projectSpecific/sports/cnr/reducers/reducerHelpers/seasonalHelpers";
import { dispatchProps } from '../../../cnr/reducers/reducerHelpers/dispatchProps';
import { dataFix } from "../../../common/dataFix";
import { createRefPath, createRefPath_client, createRefPath_event } from "../../appData/appRefPaths";
import { addPromise } from '../../promises/addPromise';
import { updateDocumentHelpers } from "./fsUpdate_document";

const _allowSubUpdate = true

export const fsUpdate_addData = async (props) => {

  const {
    baseRef,
    dispatch,
    opts,
    pathViews,
    ufProps,
    database_fns,
    appSettings_fns,
    mainDb,
    relatedDocsToUpdate,
  } = props

  const { refPath, directCollection } = baseRef
  let { vit, itemData, selectedDataItems, viDeps, dataRestrictions, appUser, storagePaths, autoUpdateCollectionRelationships, staticViewKeys, useTimestamps, appDataSource } = ufProps ?? {}
  let { useSubDataCollection, subDataCollectionName } = viDeps ? viDeps : {}

  const { useAppDataDocuments, useAppDataDocumentsOnly, updateAppDataDocuments } = appDataSource ?? {}

  let _updateAppDataDocuments = updateAppDataDocuments || useAppDataDocuments

  const _itemData = dataFix.removeAllEmpties(itemData)
  const pks = seasonalHelpers.getPks(pathViews)

  if (dataRestrictions && (dataRestrictions.all || dataRestrictions.addData)) {
    dispatch({ type: dispatchProps.successAlt, dispatch })
    return false
  }

  if (useSubDataCollection && subDataCollectionName) {
    fsUpdate_subCollection(database_fns, pathViews, pks, vit, _itemData, dispatch)
  } else {

    const callback_add = (results) => {

      if (opts && opts.settingsProps) {
        appSettings_fns.createNewViewAndViewItemsSettingsDB(opts.settingsProps, pathViews).then(
          dispatch && dispatch({ type: dispatchProps.success, dispatch })
        )
      }

      const { dataToUpdate, res } = results ?? {}
      const { id: viewKey } = res ?? {}

      // autoUpdateCollectionRelationships && fsUpdate_updateRelatedCollections(pathViews, vit, null, dataToUpdate, viewKey, staticViewKeys)

      if (_updateAppDataDocuments) {
        updateDocumentHelpers.update_itemInDocuments(null, null, database_fns, pathViews, vit, viewKey, _itemData, null, _updateAppDataDocuments)
      }

      dispatch && dispatch({ ...results, dispatch })
    }

    if (useTimestamps) {
      itemData._ts = { _updateDate: serverTimestamp() }
      if (appUser) {
        itemData._uid = appUser.uid
        itemData._user = appUser.displayName
      }
    }

    if (_itemData && (!selectedDataItems || Object.keys(selectedDataItems).length === 0)) {
      switch (vit) {
        default:

          const batchInfos = []
          const batch = writeBatch(mainDb);

          // primary doc
          const _addRef = createRefPath([vit], refPath)
          const collection_primary = collection(mainDb, _addRef);
          const primaryRef = doc(collection_primary);   // <-- auto-id generated here
          const docId = primaryRef.id;             // <-- THIS is the key you need

          // const doc_primary = doc(mainDb, _addRef)
          batch.set(primaryRef, _itemData);
          batchInfos.push({ refPath: primaryRef.path, _itemData })

          // _document doc
          const baseRef = createRefPath_event(pathViews)
          const _refPathDoc = createRefPath(['_documents', vit], baseRef)
          const doc_docs = doc(mainDb, _refPathDoc)
          const docToUpdate = { [docId]: _itemData }
          batch.set(doc_docs, docToUpdate, { merge: true });
          // batch.set(doc_docs, _itemData, { merge: true })
          batchInfos.push({ refPath: _refPathDoc, dataToUpdate: docToUpdate })

          const ref_path_ts = createRefPath(['_timeStamps', 'eventInfo'])
          const doc_ts = doc(mainDb, ref_path_ts)
          const tsToUpdate = {
            [pathViews.events]: Date.now()
          }
          batch.set(doc_ts, tsToUpdate, { merge: true })
          batchInfos.push({ refPath: ref_path_ts, dataToUpdate: tsToUpdate })

          console.log('batchInfos', batchInfos)
          await batch.commit()

          dispatch && dispatch({ type: dispatchProps.success, dispatch })
      }
    } else {
      if (selectedDataItems) {
        if (!useAppDataDocumentsOnly) {
          addPromise(database_fns, refPath, vit, directCollection, selectedDataItems).then((newItem) => {
            callback_add({ type: dispatchProps.success, addPath: refPath, newItem })
            // if (opts && opts.settingsProps) {
            //   createNewViewAndViewItemsSettingsDB(opts.settingsProps, pathViews).then(
            //     dispatch({ type: dispatchProps.success, dispatch })
            //   )
            // } else {
            //   callback_add({ type: dispatchProps.success, addPath: refPath })
            //   // dispatch({ type: dispatchProps.success, dispatch })
            // }
          }).catch(error => {
            console.log('addData', error)
            dispatch({ type: dispatchProps.error, error, dispatch })
          })
        } else {
          if (_updateAppDataDocuments) {
            const docKey = database_fns.get_docKey()
            updateDocumentHelpers.update_itemInDocuments(null, null, database_fns, pathViews, vit, docKey, _itemData, dispatch, _updateAppDataDocuments)
          }
        }

      }
    }
  }
}


/**
 * 
 * @param {object} pathViews 
 * @param {object} pks 
 * @param {string} documentFieldName 
 * @param {object} data 
 * @param {string} collectionName ** with _
 * @param {function} callback 
 * @description Updates the `_seasonalCollectionName` or the collectionName prefixed with an `_`
 */
export const fsUpdate_subCollection = async (database_fns, pathViews, pks, collectionName, data, callback) => {

  const subCollectionName = '_' + collectionName

  let _collectionItem;

  if (pks && !_.isEmpty(pks)) {
    _collectionItem = await seasonalHelpers.getSports_collectionItem(database_fns, pathViews, pks, subCollectionName, true)
  } else {
    if (pathViews.events) {
      const _refPath = createRefPath_event(pathViews, [subCollectionName, collectionName])
      _collectionItem = await database_fns.get_doc({ refPath: _refPath })
    } else {
      const _refPath = createRefPath_client(pathViews, [subCollectionName, collectionName])
      _collectionItem = await database_fns.get_doc({ refPath: _refPath })
    }
  }

  if (_collectionItem && !_.isEmpty(_collectionItem)) {

    const { _itemKey } = _collectionItem

    let _refPath;

    if (pathViews.events) {
      _refPath = createRefPath_event(pathViews, [subCollectionName, _itemKey])
    } else {
      _refPath = createRefPath_client(pathViews, [subCollectionName, _itemKey])
    }

    const refKey = database_fns.get_docKey()

    const dataToUpdate = { [collectionName + '.' + refKey]: data }

    _allowSubUpdate && database_fns.update_doc(_refPath, dataToUpdate, callback)

  } else {
    const _refPath = createRefPath_client(pathViews, [subCollectionName])

    console.log('_refPath', _refPath)

    // if (_refPath) {
    //   const dataToAdd = {
    //     parentKeys: pks,
    //     [collectionName]: data
    //   }

    //   _allowSubUpdate && database_fns.add_doc(_refPath, dataToAdd, callback)
    // }

  }
} 